import { Link } from "react-router-dom";
import { mangas } from "@/mocks/manga";

export default function FeaturedSection() {
  const featuredIds = ["2", "5", "8", "11", "1", "7"];
  const featuredMangas = featuredIds
    .map((id) => mangas.find((m) => m.id === id))
    .filter(Boolean) as typeof mangas;

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-6 md:mb-8">
          <div className="w-1 h-6 rounded-full bg-primary-500"></div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950">
            精选漫画
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          {featuredMangas.slice(0, 2).map((manga) => (
            <Link
              key={`featured-${manga.id}`}
              to={`/manga/${manga.id}`}
              className="group flex gap-4 p-4 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 hover:-translate-y-1 transition-all duration-300"
            >
              <div className="w-24 h-32 md:w-28 md:h-36 flex-shrink-0 rounded-lg overflow-hidden">
                <img
                  src={manga.cover}
                  alt={manga.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <span className="px-2 py-0.5 rounded-md text-xs font-medium bg-primary-100 text-primary-700">
                      {manga.categoryName}
                    </span>
                    <span className="text-xs text-yellow-500">
                      {"★".repeat(Math.floor(manga.rating / 2))}{manga.rating}
                    </span>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1">
                    {manga.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1">{manga.author}</p>
                  <p className="text-sm text-foreground-600 mt-2 line-clamp-2 leading-relaxed">
                    {manga.description}
                  </p>
                </div>
                <div className="flex items-center gap-3 mt-2 text-xs text-foreground-400">
                  <span>共{manga.chapters}话</span>
                  <span>{manga.views.toLocaleString()}次阅读</span>
                  <span className="text-accent-600 font-medium">{manga.status}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-5 mt-5">
          {featuredMangas.slice(2).map((manga) => (
            <Link
              key={`featured-sm-${manga.id}`}
              to={`/manga/${manga.id}`}
              className="group block p-3 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 hover:-translate-y-1 transition-all duration-300"
            >
              <div className="aspect-[3/4] rounded-lg overflow-hidden mb-3">
                <img
                  src={manga.cover}
                  alt={manga.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1">
                {manga.title}
              </h3>
              <div className="flex items-center gap-2 mt-1 text-xs text-foreground-400">
                <span>{manga.categoryName}</span>
                <span>·</span>
                <span className="text-yellow-500">{manga.rating}分</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}